import React, { Component } from 'react'
import moment from "moment"
import { AgGridReact } from "ag-grid-react"
import toastr from 'toastr'
import { Button, Dropdown, Form } from "semantic-ui-react"
import DatePicker from 'react-datepicker'
import ApiHelper from "services/api-helper"
import { session } from "services/session"
import FileSaver from "file-saver"
import XacNhanKhaiBaoViecLam from 'components/quan-ly-viec-lam-o-nha/xac-nhan-modal';

class QuanLyLamViecONha extends Component {
  state = {
    rowData: [],
    columnDefs: [
      { checkboxSelection: true, minWidth: 40, maxWidth: 40 },
      {
        headerName: "#",
        minWidth: 50,
        maxWidth: 50,
        suppressSorting: true,
        cellRenderer: function (params) {
          return params.rowIndex + 1;
        }
      },
      { headerName: "Họ tên", field: "HoTen" },
      { headerName: "Bộ phận", field: "TenBoPhan" },
      {
        headerName: "Từ ngày", field: "TuNgay",
        valueFormatter: function (data) {
          return moment(data.value).format('DD/MM/YYYY')
        }
      },
      {
        headerName: "Đến ngày", field: "DenNgay",
        valueFormatter: function (data) {
          return moment(data.value).format('DD/MM/YYYY')
        }
      },
      // {
      //   headerName: "Buổi", field: "Buoi",
      //   cellRenderer: function (data) {
      //     if (data.value === 1)
      //       return "Cả ngày"
      //     else if (data.value === 2)
      //       return "Sáng"
      //     else if (data.value === 3)
      //       return "Chiều"
      //   }
      // },
      // { headerName: "Số ngày", field: "SoNgay" },
      { headerName: "Nội dung", field: "NoiDung", maxWidth: 400, cellStyle: { 'white-space': 'normal' } },
      {
        headerName: "Xác nhận TN", field: "XacNhanTruongNhom",
        headerClass: 'ag-header-center',
        cellClass: 'text-center',
        cellRenderer: function (data) {
          if (data.value === null)
            return '<img src="img/InfoSmall.jpg" title="Chờ xác nhận" />'
          else if (data.value === 1)
            return `<img src="img/TT_yes.png" title="Xác nhận${data.data.NgayXacNhan && ' lúc ' + moment.utc(data.data.NgayXacNhan).format('HH:mm DD/MM')}" />`
          else if (data.value === 0)
            return '<img src="img/TT_no.png" title="Không chấp nhận" />'
        }
      },
      { headerName: "Nội dung xác nhận", field: "NoiDungXacNhan", maxWidth: 300, cellStyle: { 'white-space': 'normal' } },
      {
        headerName: "Xác nhận TP", field: "TrangThai",
        headerClass: 'ag-header-center',
        cellClass: 'text-center',
        cellRenderer: function (data) {
          if (data.value === -1)
            return '<img src="img/InfoSmall.jpg" title="Chờ xét" />'
          else if (data.value === 1)
            return `<img src="img/TT_yes.png" title="Chấp nhận${data.data.NgayDuyet && ' lúc ' + moment.utc(data.data.NgayDuyet).format('HH:mm DD/MM')}" />`
          else if (data.value === 0)
            return '<img src="img/TT_no.png" title="Không chấp nhận" />'
        }
      }
    ],
    autoGroupColumnDef: {
      flex: 1,
    },
    getRowHeight: function (params) {
      if (params.data.NoiDung.length > 100) {
        return (
          Math.floor(params.data.NoiDung.length / 2)
        );
      }
      else
        return 50
    },
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    boPhanList: [],
    boPhanSelected: null
  }
  getListBoPhan() {
    ApiHelper.GetJson('api/getDanhSachBoPhanByUser').then(res => {
      if (res.length > 1) res.unshift({ Oid: null, TenBoPhan: 'Tất cả' })
      this.setState({ boPhanList: res, boPhanSelected: res.length > 0 ? res[0].Oid : null })
      this.getData()
    }, error => {
      toastr.error(error)
    })
  }
  getData = () => {
    ApiHelper.GetJson('api/getDanhSachKhaiBaoLamViecTheoPhongBan', {
      IDBoPhan: this.state.boPhanSelected,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => {
      this.setState({ rowData: res })
      this.autoSizeAll()
    }, error => {
      toastr.error(error)
    })
  }
  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.getListBoPhan()
  }
  autoSizeAll() {
    this.gridApi.sizeColumnsToFit()
    var widthAfterSizeColsToFit = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    this.gridColumnApi.autoSizeAllColumns()
    var widthAfterAutoSize = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    if (widthAfterSizeColsToFit > widthAfterAutoSize) {
      this.gridApi.sizeColumnsToFit()
    }
  }
  duyet = (trangThai) => {
    const selectedNodes = this.gridApi.getSelectedNodes().map(q => q.data)
    if (selectedNodes.length < 1) {
      toastr.error('Chưa có dòng nào được chọn')
      return
    }
    ApiHelper.PostJson('api/duyetKhaiBaoLamViec', {
      Oid: selectedNodes.map(q => q.Oid).join(','),
      TrangThai: trangThai
    }).then(res => {
      if (res.ok) {
        toastr.success('Thành công!')
        this.getData()
      }
      else {
        toastr.error(res.message === "DON_DA_DUYET" ? "Đơn đã duyệt" : 'Lỗi!')
      }
    }, error => {
      toastr.error(error)
    })
  }
  export = () => {
    ApiHelper.Get('api/danhSachViecLamExcel', {
      IDBoPhan: this.state.boPhanSelected,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => res.blob()).then(res => {
      var date = new Date()
      var fileName = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.xlsx`
      FileSaver.saveAs(res, fileName)
    }, error => {
      toastr.error(error)
    })
  }

  exportnotcheck = () => {
    ApiHelper.Get('api/danhSachkhongKhaibaoViecLamExcel', {
      IDBoPhan: this.state.boPhanSelected,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => res.blob()).then(res => {
      var date = new Date()
      var fileName = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.xlsx`
      FileSaver.saveAs(res, fileName)
    }, error => {
      toastr.error(error)
    })
  }
  
  handleChange = (_ref) => {
    var startDate = _ref.startDate || this.state.startDate
    var endDate = _ref.endDate || this.state.endDate

    if (startDate.isAfter(endDate)) {
      _ref.startDate && (endDate = startDate)
      _ref.endDate && (startDate = endDate)
    }

    this.setState({ startDate: startDate, endDate: endDate })
  }
  handleChangeStart = (startDate) => {
    return this.handleChange({ startDate })
  }
  handleChangeEnd = (endDate) => {
    return this.handleChange({ endDate })
  }
  handleBoPhanSelected = (e, { value }) => {
    return this.setState({ boPhanSelected: value })
  }
  xacnhan = (openModal) => {
    const selectedNodes = this.gridApi.getSelectedNodes().map(q => q.data)
    if (selectedNodes.length < 1) {
      toastr.error('Chưa có dòng nào được chọn')
      return
    }
    if (selectedNodes.length > 1) {
      toastr.error('Chỉ chọn 1 dòng')
      return
    }
    this.setState({ openModal, data: selectedNodes[0] })
    if (!openModal) this.getData()
  }

  render() {
    const boPhanList = this.state.boPhanList.map(item => {
      return { value: item.Oid, text: item.TenBoPhan }
    })
    const showButton = session.WebGroupID === '00000000-0000-0000-0000-000000000001'
      || session.WebGroupID === '00000000-0000-0000-0000-000000000006'
    
    const showXacNhan = session.WebGroupID === '00000000-0000-0000-0000-000000000010'
    return (
      <div>
        <Form>
          {showButton && <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Button onClick={() => this.duyet(1)} positive>Chấp nhận</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={() => this.duyet(0)} negative>Không chấp nhận</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={this.export} color='teal'>Export Excel</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={this.exportnotcheck} color='teal'>Export Không khai báo</Button>
            </Form.Field>
          </Form.Group>}

          {showXacNhan && <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Button onClick={() => this.xacnhan(true)} positive>Xác nhận</Button>
            </Form.Field>
          </Form.Group>}

          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Dropdown selection options={boPhanList} placeholder={boPhanList.map(q => q.text)[0]}
                value={this.state.boPhanSelected}
                onChange={this.handleBoPhanSelected}
              />
            </Form.Field>
            <Form.Field>
              <DatePicker
                selected={this.state.startDate}
                selectsStart
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeStart}
                dateFormat="DD/MM/YYYY"
                placeholderText="Từ ngày"
              />
            </Form.Field>
            <Form.Field>
              <DatePicker
                selected={this.state.endDate}
                selectsEnd
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeEnd}
                dateFormat="DD/MM/YYYY"
                placeholderText="Đến ngày"
              />
            </Form.Field>
            <Form.Field>
              <Button onClick={this.getData} color="twitter">Tìm</Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <div className="ag-theme-balham" style={{ height: '500px' }}>
          <AgGridReact
            enableSorting={true}
            rowSelection="multiple"
            enableFilter={true}
            enableColResize={true}
            suppressColumnVirtualisation={true}
            onGridReady={this.onGridReady}
            columnDefs={this.state.columnDefs}
            getRowHeight={this.state.getRowHeight}
            rowData={this.state.rowData}>
          </AgGridReact>
        </div>
        {this.state.openModal &&
          <XacNhanKhaiBaoViecLam openModal={this.state.openModal}  data={this.state.data} closeModal={() => this.xacnhan(false)}  />
        }
      </div>
    )
  }
}

export default QuanLyLamViecONha


// WEBPACK FOOTER //
// ./src/components/quan-ly-viec-lam-o-nha/index.jsx